import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DASHBOARD SUMMARY APIs (Financial Overview)
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

// 1. Client Outstanding Summary (Receivables)
export const getClientOutStandingSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetClientOutStandingSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Vendor Outstanding Summary (Payables)
export const getVendorOutStandingSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetVendorOutStandingSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. FY Income / Expenses / Provisional Margin - current FY vs previous FY, company-wide
// (not CC-scoped). fyStartYear omitted => the FY containing today.
// Company Overhead card: Consolidate Cash Flow overhead % (Non-Performing / Performing CC
// expenses), current FY vs previous FY, company-wide (spGetOverheadPercentSummary)
export const getOverheadPercentSummary = async ({ fyStartYear } = {}) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetOverheadPercentSummary`,
            { params: fyStartYear ? { FYStartYear: fyStartYear } : {} }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const getFYIncomeExpenseSummary = async ({ fyStartYear } = {}) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetFYIncomeExpenseSummary`,
            { params: fyStartYear ? { FYStartYear: fyStartYear } : {} }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. This Month / Last Month Sales + Purchase - pre-tax BasicValue from ClientInvoice /
// VendorInvoice (Status != 'Rejected', by InvoiceDate), CC-scoped.
export const getMonthSalesPurchaseSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetMonthSalesPurchaseSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3a. GST position card - previous calendar month (spGetGSTPositionSummary): outward = client
// invoice GST +/- client notes, inward = all vendors' invoice GST +/- vendor notes
export const getGSTPositionSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetGSTPositionSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Stock Purchase Consolidate Summary (Tax Liabilities - previous calendar month GST)
export const getStockPurchaseConsolidateSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetStockPurchaseConsolidateSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
